// Utilities
import { createSimpleFunctional } from "../../util/index.js";
export const VListItemTitle = createSimpleFunctional('v-list-item-title');
//# sourceMappingURL=VListItemTitle.js.map